export const API_URL =
  process.env.REACT_APP_API_URL ||
  'https://qt5ufxerv5.execute-api.eu-west-1.amazonaws.com/dev/1';
export const API_AUTH_HEADER = 'Authorization';
